import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import LandingPage from "./pages/LandingPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { Header, Footer } from "./components";
import ScrollToTop from "./components/ScrollToTop";

const FooterWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isTermsPage",
})<{ isTermsPage: boolean }>(({ isTermsPage, theme }) => ({
  backgroundColor: isTermsPage
    ? "var(--background-white)"
    : "var(--background-page)",
  paddingBottom: theme.spacing(5),
  [theme.breakpoints.down("md")]: {
    paddingBottom: theme.spacing(2),
  },
}));

function AppContent() {
  const location = useLocation();
  const isTermsPage = location.pathname === "/privacy-policy";

  return (
    <div className="App">
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <FooterWrapper isTermsPage={isTermsPage}>
        <Footer />
      </FooterWrapper>
    </div>
  );
}

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AppContent />
    </Router>
  );
}

export default App;
